import { getRandomAvatarName } from '../components/avatar/avatarUserNames/avatarNamesGenerator';

export function getUserDefaultProfile(uid, fullName, email) {
    const userProfile = {
        uid,
        fullName,
        email,
        services: [],
        description: '',
        streaks: 0,
        checkin: false,
        avatar: {
            styles: {
                accessory: 'none',
                body: 'chest',
                clothing: 'shirt',
                eyebrows: 'raised',
                eyes: 'normal',
                faceMask: false,
                facialHair: 'none',
                graphic: 'redwood',
                hair: 'none',
                hat: 'none',
                lashes: false,
                mouth: 'openSmile',
            },
            colors: {
                avatarBackgroundColor: '#b0d1b9',
                hatColor: 'red',
                hairColor: 'black',
                lipColor: 'red',
                skinColor: 'light',
                clothingColor: 'green',
                faceMaskColor: 'white',
            },
        },
        created_avatar: false,
        allowDisplay: true,
        unlockedBadges: [],
        avatarName: getRandomAvatarName(),
        receiveEmail: true,
        emailReminders: {
            day: '',
            time: '09:00',
            frequency: 'Daily',
            message: 'This is a default message set already for you. You can change this to your own custom message using Email Reminders Page.',
        },
        emailReminderTime: [],
        unsubscribe: {
            token: '',
        },
    };

    return userProfile;
}
